//@flow
///* eslint-disable prefer-template, no-path-concat, import/unambiguous, import/no-commonjs */
/* eslint-disable camelcase */

import window from '../../../util/window';


// plotty is a library for helping plot 2D data and provide color scaling functionality.
//Put your array data in it and receive a fresh image.

import SmartMap from './smart-map';
import initColorscales from './colorscales';

const isNumber = function (value) {
    return value === 0 || Number(value);
};
const colorscaleLength = 1024;
class RenderRaster {
    static bind(context) {
        if (context !== RenderRaster.context) {
            RenderRaster.cache = new SmartMap();
        }
        RenderRaster.context = context;
        return RenderRaster;
    }
    static renderGradientInterval(gradient, color, pos) {
        gradient.addColorStop(pos, color);
    }
    static renderGradientExponential(gradient, color, pos) {
        gradient.addColorStop(pos, color);
    }


    static colorscale2Texture(context, colorscale) {
        const canvas = RenderRaster.colorscale2canvas(colorscale);
        const texture = RenderRaster.canvas2texture(context, canvas);
        return texture;
    }

    static colorscale2canvas(colorscale) {
        if (Object.prototype.toString.call(colorscale) === "[object Object]") {
            return RenderRaster.objectScale2canvas(colorscale);
        } else if (Object.prototype.toString.call(colorscale) === "[object Uint8Array]") {
            return RenderRaster.typedArray2canvas(colorscale);
        } else {
            throw new Error("Color scale not defined.");
        }
    }
    static objectScale2canvas(colorScale) {
        const canvas = window.document.createElement("canvas");
        canvas.width = colorscaleLength;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        const gradient = ctx.createLinearGradient(0, 0, colorscaleLength, 1);
        const type = colorScale.type;

        if (colorScale.stops) {
            const stops = colorScale.stops;
            const min = isNumber(colorScale.min) ? colorScale.min : stops[0][0] || 0;
            const max = isNumber(colorScale.max) ? colorScale.max : stops[stops.length - 1][0] || 1;
            //æ­¤å¤ä¸ºååéçï¼ç®åæçº¿æ§è¿æ¸¡ï¼ä»¥åå¯ä»¥å¢å åç§éçº¿æ§åå
            const calc = (pos) => {
                return (pos - min) / (max - min);
            };
            colorScale.stops.forEach(([pos, color], index) => {
                if (type === 'interval') {
                    if (index < colorScale.stops.length - 1) {
                        RenderRaster.renderGradientInterval(gradient, color, calc(pos));
                        RenderRaster.renderGradientInterval(gradient, color, calc(colorScale.stops[index + 1][0]));
                    } else {
                        const factorPos = calc(pos);
                        RenderRaster.renderGradientInterval(gradient, color, factorPos);
                    }
                } else {
                    RenderRaster.renderGradientExponential(gradient, color, calc(pos));
                }
            });
        } else {
            const min = isNumber(colorScale.min) ? colorScale.min : colorScale.positions[0] || 0;
            const max = isNumber(colorScale.max) ? colorScale.max : colorScale.positions[colorScale.positions.length - 1] || 1;
            const calc = (pos) => {
                return (pos - min) / (max - min);
            };
            colorScale.positions.forEach((pos, index) => {
                const color = colorScale.colors[index];
                if (index < colorScale.positions.length - 1 && type === 'interval') {
                    RenderRaster.renderGradientInterval(gradient, color, calc(pos), calc(colorScale.positions[index + 1]));
                } else {
                    RenderRaster.renderGradientExponential(gradient, color, calc(pos));
                }
            });
        }
        ctx.fillStyle = gradient;
        ctx.fillRect(0, 0, colorscaleLength, 1);
        return canvas;
    }
    static typedArray2canvas(colorScale) {
        const canvas = window.document.createElement("canvas");
        canvas.width = colorscaleLength;
        canvas.height = 1;
        const ctx = canvas.getContext("2d");
        const imgData = ctx.createImageData(colorscaleLength, 1);
        imgData.data.set(colorScale);
        ctx.putImageData(imgData, 0, 0);
        return canvas;
    }

    static canvas2texture(context, canvas) {
        if (!context) return;
        const gl = context.gl;
        // ä¸ºäºä¸å½±åä¹åçæµç¨çåæ°
        const preValue = context.pixelStoreUnpackPremultiplyAlpha.get();
        context.pixelStoreUnpackPremultiplyAlpha.set(true);
        const textureScale = gl.createTexture();
        gl.bindTexture(gl.TEXTURE_2D, textureScale);
        // Set the parameters so we can render any size image.
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.NEAREST);
        gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.NEAREST);
        // Upload the image into the texture.
        gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, canvas);
        context.pixelStoreUnpackPremultiplyAlpha.set(preValue);
        return textureScale;
    }
    static getTexture(name) {
        if (!name) {
            return null;
        }
        if (!RenderRaster.context) {
            console.error(`RenderRaster need bind context`);
        }
        
        if (typeof name === 'string' && RenderRaster.colorscales[name]) {
            if (RenderRaster.cache.has(name)) {
                return RenderRaster.cache.get(name);
            }
            RenderRaster.cache.set(name, RenderRaster.colorscale2Texture(RenderRaster.context, RenderRaster.colorscales[name]));
            return RenderRaster.cache.get(name);
        }else{
            // ä¸ºäºåæ·±åº¦å¯¹æ¯
            let jsonName = JSON.stringify(name);
            if (RenderRaster.cache.has(jsonName)) {
                return RenderRaster.cache.get(jsonName);
            }
            RenderRaster.cache.set(jsonName, RenderRaster.colorscale2Texture(RenderRaster.context, name));
            return RenderRaster.cache.get(jsonName);
        }
        
    }
    static addColorScale(name, colorscale, render = false) {
        RenderRaster.colorscales[name] = colorscale;
        if (render) {
            return RenderRaster.getTexture(name);
        } else {
            return RenderRaster.colorscales[name];
        }
    }
}
// RenderRaster.cache = {};
RenderRaster.cache = new SmartMap();

RenderRaster.colorscales = initColorscales;
export default RenderRaster;
